<script lang="ts">
	import '@awesome.me/kit-f1d1181ead/icons/css/all.min.css';
	import { page } from '$app/stores';
	import { goto, onNavigate } from '$app/navigation';
	import Search from '$components/Search.svelte';
	import Cart from '$components/Cart.svelte';
	import { isCartOpen } from '$stores/cartComponentManager';
	import { cart } from '$stores/cart';

	export let searchData: Array<any> = [];

	let navLinks = [
		{ link: '/', type: 'text', text: 'Home', id: 'shopMenu' },
		{
			link: '/shop',
			type: 'expandable',
			text: 'Shop',
			urlParam: 'category',
			subLinks: [
				'Layer Cakes',
				'Cupcakes',
				'Other Desserts',
				'Sweet Additions',
				'Pies'
			]
		},

		{ link: '/media', type: 'text', text: 'Media' },
		{ link: '/about', type: 'text', text: 'About' }
	];

	let expandableSections: Array<HTMLDetailsElement> = [];

	onNavigate((url) => {
		expandableSections.forEach((section) => {
			if (section.open) {
				section.removeAttribute('open');
			}
		});
	});
</script>

<nav class="flex w-full">
	<ul class="flex w-full">
		{#each navLinks as link}
			<li class="mx-auto my-auto flex gap-12">
				{#if link.type == 'text'}
					<a
						class="block border-logoFontGold px-4 py-2 text-base font-medium hover:text-gray-600 focus:text-gray-600 aria-current:border-y-2"
						href={link.link}
						aria-current={$page.url.pathname === link.link}>{link.text}</a
					>
				{:else if link.type == 'expandable'}
					<details
						bind:this={expandableSections[expandableSections.length]}
						class="group relative [&_summary::-webkit-details-marker]:hidden"
					>
						<summary
							class="flex cursor-pointer items-center justify-between gap-2 border-logoFontGold px-4 py-2 text-gray-900 hover:text-gray-600 focus:text-gray-600 aria-current:border-y-2"
							aria-current={$page.url.pathname === link.link}
						>
							<span class="text-base font-medium">{link.text}</span>
							<span
								class="fa-solid fa-angle-down shrink-0 text-base text-logoBackgroundBlue transition duration-300 group-open:-rotate-180"
							/>
						</summary>
						<ul
							class="absolute z-10 mt-2 w-fit space-y-1 text-nowrap rounded-md border border-gray-200 bg-white p-2 text-gray-500"
						>
							<li
								class="my-auto hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
							>
								<a
									class="aria-current: block px-4 py-2 text-sm"
									href={link.link}
									aria-current={$page.url.pathname === link.link}>All</a
								>
							</li>
							{#if link.subLinks}
								{#each link.subLinks as subLink}
									<li
										class="my-auto hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
									>
										<a
											class="block px-4 py-2 text-sm"
											href={`${link.link}?${link.urlParam}=${subLink.replace(' ', '%20')}`}
											aria-current={$page.url.pathname ===
												`${link.link}?${link.urlParam}=${subLink.replace(' ', '%20')}`}
											>{subLink}</a
										>
									</li>
								{/each}
							{/if}
							<li role="separator" class="h-px w-full bg-gray-200"></li>
							<li
								class="my-auto hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
							>
								<a
									class="aria-current: block px-4 py-2 text-sm"
									href="/corporateOrders"
									aria-current={$page.url.pathname === '/corporateOrders'}
									>Corporate Orders</a
								>
							</li>
							<li
								class="my-auto hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
							>
								<a
									class="aria-current: block px-4 py-2 text-sm"
									href="/customCreations"
									aria-current={$page.url.pathname === '/customCreations'}
									>Custom Creations</a
								>
							</li>
							<li
								class="my-auto hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
							>
								<a
									class="aria-current: block px-4 py-2 text-sm"
									href="/specialOccasions"
									aria-current={$page.url.pathname === '/specialOccasions'}
									>Special Occasions</a
								>
							</li>
						</ul>
					</details>
				{/if}
			</li>
		{/each}
		<li class="my-auto ml-4"><Search resultsList={searchData} /></li>
		<li class="mx-4 my-auto">
			<button
				aria-haspopup="dialog"
				aria-label={$cart.items.length > 0
					? 'Cart ' + $cart.items.length
					: 'Cart'}
				id="cartButton"
				on:click={() => {
					isCartOpen.set(true);
				}}
			>
				<span class="fa-duotone fa-cart-shopping text-logoBackgroundBlue" />
				{#if $cart.items.length > 0}
					<sup
						aria-hidden="true"
						class="rounded-full bg-logoFontPurple px-1 text-xs text-white"
					>
						{$cart.items.length}
					</sup>
				{/if}
			</button>
		</li>
	</ul>
</nav>
